import * as React from "react"
import '../scss/title.scss'

const Title = ({ title, subtitle, small, reverse, asH1, className }: {
  title: string,
  subtitle?: string | null,
  small?: boolean,
  reverse?: boolean,
  asH1?: boolean,
  className?: string
}) => {
  return <div className={"Title__Container "
    + (small ? "Title__Container--small " : "")
    + (reverse ? "Title__Container--reverse " : "") + className}>
    {asH1 ?
      <h1 className="Title__Title">
        {title}
      </h1> :
      <h2 className="Title__Title">
        {title}
      </h2>
    }
    <div className="Title__Subtitle">
      {subtitle}
    </div>
  </div>
}

export default Title